import { render, staticRenderFns } from "./ContratoLogs.vue?vue&type=template&id=30223776&scoped=true"
import script from "./ContratoLogs.vue?vue&type=script&lang=js"
export * from "./ContratoLogs.vue?vue&type=script&lang=js"
import style0 from "./ContratoLogs.vue?vue&type=style&index=0&id=30223776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30223776",
  null
  
)

export default component.exports